module.exports = __webpack_public_path__ + "img/icon_user.94d6c6e7.svg";